import Api from '@/api'
import { getAuthHeaders } from '@/helpers/getServerSideCookies'
import { checkIsWhiteLabel } from '@/helpers/checkEnvironments'
import { whiteLabelsApi } from '@/helpers/whiteLabelsAPI'

export const fetchApi = async (
  endpoint: string,
  params: any = {},
  req: any = {},
) => {
  const { xsrfToken, origin } = getAuthHeaders(req.headers)
  const selectedHeaders: any = {
    origin,
    cookie: req.headers?.cookie,
    ...(req.headers['x-deviceId']
      ? { 'x-deviceId': req.headers['x-deviceId'] }
      : {}),
    ...(xsrfToken ? { 'x-xsrf-token': xsrfToken } : {}),
  }
  const baseUrl =
    checkIsWhiteLabel() && whiteLabelsApi[req.host]
      ? { baseURL: whiteLabelsApi[req.host] }
      : {}
  const api = new Api({ headers: selectedHeaders, ...baseUrl })
  try {
    const res = await api.get(endpoint, params)
    return res.data
  } catch (error) {
    console.error('Error in fetch:', error)
    return
  }
}
